import React, { useState, useEffect, useContext } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import Circle from "./Circle";
import footerAudioWhite from "../../assets/icons/footerAudioWhite.svg";
import footerCheckWhite from "../../assets/icons/footerCheckWhite.svg";
import footerLettersWhite from "../../assets/icons/footerLettersWhite.svg";
import footerMenu from "../../assets/icons/footerMenu.svg";
import footerPaintWhite from "../../assets/icons/footerPaintWhite.svg";
import footerPointerWhite from "../../assets/icons/footerPointerWhite.svg";
import footerAudioBlue from "../../assets/icons/footerAudioBlue.svg";
import footerCheckBlue from "../../assets/icons/footerCheckBlue.svg";
import footerLettersBlue from "../../assets/icons/footerLettersBlue.svg";
import footerPaintBlue from "../../assets/icons/footerPaintBlue.svg";
import footerPointerBlue from "../../assets/icons/footerPointerBlue.svg";
import { BuildContext } from "../../context/BuildSpotlightState";

const SpotlightFooter = ({ currentStep }) => {
  const { lastCompleted, setStage } = useContext(BuildContext);
  const handleClick = (step) => {
    if (step <= lastCompleted) {
      setStage(step);
    } else {
      return;
    }
  };

  return (
    <div className={container + ` step-${lastCompleted}`}>
      <div className="circlesBorderBox">
        <div className="borderCircle"></div>
        <div className="borderCircle"></div>
        <div className="borderCircle"></div>
        <div className="borderCircle"></div>
        <div className="borderCircle"></div>
        <div className="borderCircle"></div>
      </div>
      <div className="borderBar"></div>
      <div className="filledBar"></div>

      <div className="circlesClearBox">
        <div className="clearCircle"></div>
        <div className="clearCircle"></div>
        <div className="clearCircle"></div>
        <div className="clearCircle"></div>
        <div className="clearCircle"></div>
        <div className="clearCircle"></div>
      </div>
      <div className="circlesFilledBox">
        <Circle
          index={0}
          currentStep={currentStep}
          iconActive={footerMenu}
          handleClick={() => handleClick(1)}
        />
        <Circle
          index={1}
          currentStep={currentStep}
          iconInactive={footerLettersBlue}
          iconActive={footerLettersWhite}
          handleClick={() => handleClick(1)}
        />
        <Circle
          index={2}
          currentStep={currentStep}
          iconInactive={footerAudioBlue}
          iconActive={footerAudioWhite}
          handleClick={() => handleClick(2)}
        />
        <Circle
          index={3}
          currentStep={currentStep}
          iconInactive={footerPointerBlue}
          iconActive={footerPointerWhite}
          handleClick={() => handleClick(3)}
        />
        <Circle
          index={4}
          currentStep={currentStep}
          iconInactive={footerPaintBlue}
          iconActive={footerPaintWhite}
          handleClick={() => handleClick(4)}
        />
        <Circle
          index={5}
          currentStep={currentStep}
          iconInactive={footerCheckBlue}
          iconActive={footerCheckWhite}
          handleClick={() => handleClick(5)}
        />
      </div>
    </div>
  );
};

export default SpotlightFooter;

const container = css`
  display: flex;
  height: 90px;
  position: relative;
  align-items: center;

  .circlesBorderBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    height: 100%;
    width: 100%;
    z-index: -1;
  }

  .borderCircle {
    height: 45px;
    width: 45px;
    background-color: white;
    box-shadow: 0 0 0 1px #e0e0e0;
    border-radius: 50%;
    justify-content: center;
  }

  .borderBar {
    position: absolute;
    left: 2px;
    background-color: white;
    border: solid 1px #e0e0e0;
    height: 18px;
    width: 95%;
  }

  .filledBar {
    position: absolute;
    left: 6px;
    height: 8px;
    width: 14%;
    background-color: ${colors.brandColor};
    /* background-color: black; */
    z-index: 4;
    transition-duration: 1.55s;
    border-radius: 5px;
  }

  .circlesClearBox {
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  .clearCircle {
    height: 45px;
    width: 45px;
    background-color: white;
    border-radius: 50%;
    justify-content: center;
  }

  .circlesFilledBox {
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    height: 100%;
    width: 100%;
    z-index: 5;
  }

  &.step-1 {
    .filledBar {
      width: calc(calc(200% / 6) - 8px);
    }
  }

  &.step-2 {
    .filledBar {
      width: calc(calc(300% / 6) - 7px);
    }
  }
  &.step-3 {
    .filledBar {
      width: calc(calc(400% / 6) - 6px);
    }
  }
  &.step-4 {
    .filledBar {
      width: calc(500% / 6);
    }
  }
  &.step-5 {
    .filledBar {
      width: calc(calc(600% / 6) - 12px);
    }
  }
  
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .borderBar {
      box-shadow: 0 0 30px 0 rgba(0,0,0,.14);
    }
  }
`;
